import React from 'react';
import SliderModal from './SliderModal';
import styled, { keyframes } from 'styled-components';

/*global tw */

const fadeUp = keyframes`
    from { opacity: 0; transform: translateY(6px); }
    to   { opacity: 1; transform: translateY(0); }
`;

const ModalInner = styled.div`
    ${tw`w-full flex items-center flex-wrap px-6 py-8`};
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
`

const ModalLabel = styled.p`
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-size: 0.6875rem;
    font-weight: 700;
    color: #CB53D1;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    margin: 0 0 0.5rem 0;
`

const ModalHeading = styled.h3`
    ${tw`w-full font-bold tracking-tight mb-4`};
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-size: 1.375rem;
    font-weight: 700;
    color: #F5F5F7;
    letter-spacing: -0.03em;
    margin-top: 0;
    &::after {
        content: '';
        display: block;
        margin-top: 0.75rem;
        height: 2px;
        width: 2rem;
        background: linear-gradient(90deg, #AA0BCA, #5500DB);
        border-radius: 2px;
    }
`

const OptionList = styled.ul`
    ${tw`list-reset w-full`};
    margin: 0;
    padding: 0;
`

const OptionItem = styled.li`
    ${tw`w-full cursor-pointer`};
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-size: 1rem;
    font-weight: 600;
    color: #9898A8;
    padding: 0.875rem 1rem;
    margin: 0.375rem 0;
    border-radius: 6px;
    border: 1px solid rgba(170,11,202,0.12);
    background: rgba(170,11,202,0.04);
    transition: all 0.18s ease;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    animation: ${fadeUp} 0.2s ease both;
    animation-delay: ${props => props.index * 0.05}s;
    &::before {
        content: '';
        display: block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #AA0BCA;
        flex-shrink: 0;
        opacity: 0.6;
        transition: opacity 0.15s ease;
    }
    &:hover {
        background: rgba(170,11,202,0.12);
        border-color: rgba(170,11,202,0.35);
        color: #F5F5F7;
        transform: translateX(4px);
        &::before { opacity: 1; }
    }
`

const PackagesModal = (props) => (
    <SliderModal active={props.active}>
       {props.type == 'hourly' && (
           <ModalInner>
               <ModalLabel>Duration</ModalLabel>
               <ModalHeading>How long do you need the rental?</ModalHeading>
               <OptionList>
                   <OptionItem index={0} onClick={() => props.onClick(6, false)}>8 hrs, 80kms</OptionItem>
               </OptionList>
           </ModalInner>
       )}
       {props.type === 'airport' && (
           <ModalInner>
               <ModalLabel>Transfer Type</ModalLabel>
               <ModalHeading>Choose airport pickup / dropoff</ModalHeading>
               <OptionList>
                   <OptionItem index={0} onClick={() => props.airportTypeClick('Airport Pickup', false)}>Airport Pickup</OptionItem>
                   <OptionItem index={1} onClick={() => props.airportTypeClick('Airport Dropoff', false)}>Airport Dropoff</OptionItem>
               </OptionList>
           </ModalInner>
       )}
    </SliderModal>
);

export default PackagesModal;
